import { render, staticRenderFns } from "./SetPassword.vue?vue&type=template&id=4848d45a&"
import script from "./SetPassword.vue?vue&type=script&lang=ts&"
export * from "./SetPassword.vue?vue&type=script&lang=ts&"
import style0 from "@/styles/landing/auth.scss?vue&type=style&index=0&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput})
